module.exports = __webpack_public_path__ + "static/media/desert-world-full.c5d0cef2.jpg";